var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPremiumhat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84384 6.44202C4.18229 6.44202 2.5207 6.44092 0.859151 6.44456C0.749388 6.44478 0.706895 6.41998 0.690021 6.30511C0.577657 5.54061 0.456418 4.77738 0.338691 4.01366C0.228961 3.3019 0.12232 2.58965 0.00911161 1.87844C-0.0198245 1.69682 0.0163944 1.54769 0.172292 1.44173C0.314599 1.345 0.482981 1.35785 0.646454 1.47967C1.34911 2.00341 2.05096 2.5282 2.7519 3.05422C3.10232 3.31715 3.40293 3.2673 3.64703 2.9016C4.23684 2.01808 4.826 1.13413 5.41695 0.251316C5.59827 -0.0195452 5.91419 -0.0783928 6.15443 0.108652C6.21331 0.154494 6.25268 0.215748 6.29329 0.276481C6.88791 1.16641 7.48367 2.05557 8.07683 2.94647C8.20567 3.14002 8.37757 3.23427 8.61166 3.21314C8.7263 3.2028 8.81883 3.14636 8.90713 3.08029C9.60244 2.56009 10.2974 2.03941 10.9926 1.51901C11.0671 1.46325 11.1388 1.40174 11.2353 1.38577C11.5067 1.34081 11.7329 1.55139 11.6922 1.82427C11.5877 2.52452 11.4756 3.22367 11.3676 3.92341C11.2491 4.69109 11.1302 5.45878 11.0148 6.22695C10.9826 6.44121 10.9879 6.44202 10.7676 6.44202H5.84384Z",
    fill: "url(#paint0_linear_349_394)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.856 7.29421C7.51729 7.29421 9.17858 7.29517 10.8399 7.29208C10.9468 7.2919 10.9873 7.31257 10.984 7.42999C10.9752 7.75402 10.9821 8.07849 10.9807 8.40272C10.9791 8.77903 10.7576 8.99965 10.382 8.9997C7.35596 8.99984 4.3299 8.99988 1.30383 8.9997C0.928308 8.99965 0.70748 8.77901 0.706084 8.40197C0.704882 8.07361 0.710341 7.74516 0.703223 7.41699C0.700917 7.3104 0.739118 7.29215 0.835581 7.29231C2.50903 7.29495 4.18252 7.29421 5.856 7.29421Z",
    fill: "url(#paint1_linear_349_394)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_349_394",
    x1: 15.6596,
    y1: -3.94428,
    x2: -1.88712,
    y2: -3.94428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45668,
    stopColor: "#FF778E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B97AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_349_394",
    x1: 14.4672,
    y1: 6.24689,
    x2: -0.95557,
    y2: 6.24689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45668,
    stopColor: "#FF778E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B97AFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumhat);
export default __webpack_public_path__ + "static/media/premiumhat.37843f9868c491a349080192902375da.svg";
export { ForwardRef as ReactComponent };